<template>
  <LoadingWrapper :state="status">
    <JournalSlide
      v-if="data.analysis.progress.length > 0"
      :feedback-topic="data.feedbackTopic"
      :member="dialog.coachee"
      :latest-value="data.analysis.latestValue"
      :progress="data.analysis.progress"
      :questions="data.analysis.questions"
      :scale="data.analysis.scale"
    />
    <div v-else class="flex h-full flex-col items-center justify-center">
      <BaseEmptyVisual class="max-w-sm" />
      <p class="text-body-large lg:text-title-large">
        Es sind noch keine Feedbackdaten freigegeben.
      </p>
    </div>
  </LoadingWrapper>
</template>
<script lang="ts" setup>
  import LoadingWrapper from '../../../core/components/loading/LoadingWrapper.vue'
  import { useFinalJournalSlide } from '../composable/use-final-journal-slide'
  import JournalSlide from './JournalSlide.vue'
  import { useRoute } from 'vue-router'
  import { computed } from 'vue'
  import BaseEmptyVisual from '@/core/components/base/empty-visual/BaseEmptyVisual.vue'
  import { injectStrict } from '@/core/utils/inject-strict'
  import { dialogKey } from '../composable/use-dialog-navigation'

  const route = useRoute()
  const feedbackTopicId = computed(() => route.params.feedbackTopicId as string)
  const { status, data } = useFinalJournalSlide(feedbackTopicId)
  const dialog = injectStrict(dialogKey)
</script>
